// extracted by mini-css-extract-plugin
export default {"w-full":"Video_w-full__G8ei-","deleteButton":"Video_deleteButton__xPRmX"};